import posthog from './posthog';

export const FEATURE_FLAGS = Object.freeze({
    pinkButtons: 'pink_buttons_enabled',
});

export function getFeatureFlagResult(key) {
    return posthog.getFeatureFlagResult?.(key);
}

export function isFeatureEnabled(key, fallback = false) {
    const result = getFeatureFlagResult(key);
    if (!result) return fallback;
    return Boolean(result.enabled);
}

export function getFeaturePayload(key, fallback = null) {
    const result = getFeatureFlagResult(key);
    return result?.payload ?? fallback;
}

export function getFeatureVariant(key, fallback = null) {
    const result = getFeatureFlagResult(key);
    return result?.variant ?? fallback;
}

export function onFeatureFlagsReady(callback) {
    if (typeof posthog.onFeatureFlags !== 'function') {
        callback({ errorsLoading: true });
        return () => {};
    }

    return posthog.onFeatureFlags((flags, variants, context) => {
        callback(context || {});
    });
}
